import { WorkstationState } from '@connect-x-app/shared-domain-models';

import { formatDateTimeLongNoZone, ISO8601_REGEX } from '../../date-time';

export const WorkstationLabelMap = new Map<keyof WorkstationState, string>([
  ['aircraftRegistrations', 'WORKSTATION.LABEL.AIRCRAFT_REGISTRATION'],
  ['arrivalFrom', 'WORKSTATION.LABEL.ARRIVAL_FROM'],
  ['arrivalTo', 'WORKSTATION.LABEL.ARRIVAL_TO'],
  ['atcCallSigns', 'WORKSTATION.LABEL.CALL_SIGN'],
  ['departureFrom', 'WORKSTATION.LABEL.DEPARTURE_FROM'],
  ['departureGates', 'WORKSTATION.LABEL.DEPARTURE_GATE'],
  ['departureAirports', 'WORKSTATION.LABEL.DEPARTURE_AIRPORT'],
  ['departureTo', 'WORKSTATION.LABEL.DEPARTURE_TO'],
  ['desks', 'WORKSTATION.LABEL.DESK'],
  ['destinationGates', 'WORKSTATION.LABEL.DESTINATION_GATE'],
  ['destinationAirports', 'WORKSTATION.LABEL.DESTINATION_AIRPORT'],
  ['flightNumbers', 'WORKSTATION.LABEL.FLIGHT_NUMBER'],
]);

export const mapAppliedWorkstation = (
  workstation: WorkstationState | null,
): {
  key: keyof WorkstationState;
  label: string;
  value: string;
}[] => {
  if (workstation) {
    return Object.entries(workstation)
      .filter(([, value]) => !!value)
      .filter(([key]) => !key.endsWith('Time'))
      .map(([key, value]) => {
        const mappedKey = key as keyof WorkstationState;
        if (Array.isArray(value)) {
          return value.map((v: string) => ({ key: mappedKey, label: v, value: v }));
        }

        if (typeof value === 'string' && ISO8601_REGEX.FULL.test(value)) {
          return [
            {
              key: key as keyof WorkstationState,
              label: '',
              value: formatDateTimeLongNoZone(value, true) ?? '',
            },
          ];
        }

        return [];
      })
      .flat();
  }

  return [];
};

export const getWorkstationPillKey = (key: keyof WorkstationState, label: string) => {
  return `${key}${label ? '-' + label : ''}`;
};
